import { Snackbar } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { default as Alert, default as MuiAlert } from "@material-ui/lab/Alert";
import instance from "api/globalaxios";
import { CLAIMANT, INDIAN_STATES } from "app/constants";
import { triggerOrixEmail } from "Clients/OrixIndia/API/service";
import SearchAutocomplete from "Components/SearchAutoComplete";
import { useSnackbar } from "contexts/SnackbarContext";
import FormattedMessage from "features/common/TranslatedMessage";
import { introFormContext } from "features/intro/IntroContainerBeforeLogin";
import { useFormik } from "formik";
import { useMuthootRegions } from "hooks";
import useLoanTypes from "hooks/useLoanTypes";
import debounce from "lodash/debounce";
import React, { Fragment, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import {
  isCDR,
  isDigipub,
  isHotStar,
  isMuthoot,
  isNbf,
  isOrix,
  isStar,
  isViacom,
  isVikalp,
  isWebnyay,
} from "Routes/Routes";
import { createCaseAnonymous } from "slices/casesSlice";
import { getCompanyProductsAnonymous } from "slices/companySlice";
import { createDisputeAnonymous, getRealhost, updateDisputeAnonymous } from "slices/disputeSlice";
import { getCitiesByStateName } from "slices/userSlice";
import * as Yup from "yup";

function Aler(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  formContainer: {
    padding: "2rem",
  },
  hoverButton: {
    background: "#3F51B5",
    color: "#FFFFFF",
    border: "1px solid transparent",
    "&:hover": {
      backgroundColor: "transparent",
      color: "#3F51B5",
      border: "1px solid #3F51B5",
    },
  },
}));

const DisputeSchema = Yup.object().shape({
  email: Yup.lazy(() =>
    isMuthoot
      ? Yup.string().email("Invalid email")
      : Yup.string().required("Email field is required").email("Invalid email"),
  ),
  phone: Yup.string()
    .matches(/^[0-9]+$/, "Invalid phone number")
    .min(10, "Must be exactly 10 digits")
    .max(10, "Must be exactly 10 digits"),
  company: Yup.number()
    .required()
    .typeError("Please select a company from the dropdown."),
  company_product_type: Yup.string()
    .required()
    .typeError("Please select an option from the dropdown"),
  company_product: Yup.lazy(() =>
    isMuthoot
      ? Yup.string().required().typeError("Please set the company product to proceed")
      : Yup.number().required().typeError("Please set the company product to proceed"),
  ),
});

const IntroForm = ({ companies, profile: loggedInProfile }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [profile, setProfile] = useState();
  const [user, setUser] = useState();
  const [companyName, setCompanyName] = useState("");
  const caseLoading = useSelector((state) => state.cases.loading);
  const disputeLoading = useSelector((state) => state.disputes.loading);
  const { isVendor, setFormStep, setClaimantFormValues } = useContext(introFormContext);
  let history = useHistory();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const { regions } = useMuthootRegions();
  const { loanTypes } = useLoanTypes(isMuthoot);

  const [companyProducts, setCompanyProducts] = React.useState([]);
  const [cities, setCities] = useState([]);
  const [complainCategory, setComplainCategory] = useState("");

  const previousFormData = location.state?.formData || null;
  const disputeId = location?.state?.disputeId || null;
  const [errors, setErrors] = useState(null);

  const isCallCenterProfile = loggedInProfile?.profile_type === "witness";


  const grievanceTypes = [
    { id: "query", value: "Query" },
    { id: "request", value: "Request" },
    { id: "complaint", value: "Complaint" },
  ];

  const orixBusinessChoices = [
    { label: "Lease Business", value: "lease_business" },
    { label: "Finance Lease", value: "finance_lease" },
    { label: "Loan Against Property", value: "loan_against_property" },
    { label: "Commercial Vehicle Loan", value: "commercial_vehicle_loan" },
    { label: "Corporate Loan", value: "corporate_loan" },
    { label: "Equipment Loan", value: "equipment_loan" },
    { label: "Any Other Loan", value: "any_other_loan" },
    { label: "Operating Lease", value: "operating_lease" },
    { label: "Mychoize", value: "Mychoize" },
    { label: "BTS", value: "BTS" },
    { label: "Rent A Car", value: "rent_a_car" },
  ];

  const sourceOfComplaints = ["Customer", "Call Center", "Regional Officer", "Email", "Phone"];

  const booleanDropdown = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];

  useEffect(() => {
    (isVendor || isOrix || previousFormData?.company_product) &&
      getCompanyProductsAnonymous(profile?.company || companies[0]?.id).then((response) => {
        setCompanyProducts(response);
        if (isOrix) {
          formik.setFieldValue("company_product", response?.[0]?.id);
          formik.setFieldValue("company_product_type", response?.[0]?.id);
          formik.setFieldValue("company", companies?.[0]?.id);
        } else if (previousFormData?.company_product) {
          formik.setFieldValue("company_product", previousFormData.company_product);
          formik.setFieldValue("company_product_type", response.find(item => item.id === previousFormData.company_product)?.type);
        }
      });
  }, [companies, previousFormData?.company_product]);

  const [openSnackBar1, setOpenSnackBar1] = useState(false);
  const handleCloseSnackBar1 = () => setOpenSnackBar1(false);

  const categorizeInput = (input, businessVertical) => {
    const olfsPrefixes = [
      /^F\/DISB0\w{5}$/, // Matches F/DISB0XXXXX
      /^F\/TRF\w{5}$/,  // Matches F/TRFXXXXX
      /^DMFL020000\w{5}$/, // Matches DMFL020000XXXXX
      /^TRFL020000\w{5}$/, // Matches TRFL020000XXXXX
      /^EXFL020000\w{5}$/,  // Matches EXFL020000XXXXX
      /^LN00000000\w{5}$/, // Matches LN00000000XXXXX
    ];

    const ocilPrefixes = [
      /^DISB0\w{5}$/, // Matches DISB0XXXXX
      /^TROL020000\w{5}$/, // Matches TROL020000XXXXX
      /^DMOL020000\w{5}$/, // Matches DMOL020000XXXXX
      /^EXOL020000\w{5}$/  // Matches EXOL020000XXXXX
    ];

    const checkByInputText = (inputText) => {
      for (const pattern of olfsPrefixes) {
        if (pattern.test(inputText)) {
          return 'OLFS';
        }
      }

      for (const pattern of ocilPrefixes) {
        if (pattern.test(inputText)) {
          return 'OCIL';
        }
      }

      return 'UNKNOWN';
    }

    switch (businessVertical) {
      case 'finance_lease':
      case 'loan_against_property':
      case 'commercial_vehicle_loan':
      case 'corporate_loan':
      case 'equipment_loan':
      case 'any_other_loan':
        return 'OLFS';

      case 'operating_lease':
      case 'Mychoize':
      case 'BTS':
      case 'rent_a_car':
        return 'OCIL';

      case 'lease_business':
      case 'finance_lease':
      case 'operating_lease':
      default:
        return checkByInputText(input);
    }
  }

  const navigateToNextPage = (values) => {
    // add the form data to state
    console.log("navigating to next page with values:", values);
    history.replace({
      pathname: location.pathname,
      state: { formData: values }
    });
    // add the form data to history state and navigate to dispute page
    history.push({
      pathname: `/dispute`,
      state: { formData: values }
    });
  }

  // debounced submit handler for general user as claimant
  const debouncedOnSubmit = debounce((values) => {
    if (isOrix && !values.existingCustomer) {
      history.push('/annexure1');
      triggerOrixEmail('annexure1', values?.email);
      return;
    }
    if (isOrix && !values.helpDeskComplainRaised) {
      history.push('/annexure2');
      triggerOrixEmail('annexure2', values?.email);
      return;
    }
    if (isOrix && (complainCategory === 'UNKNOWN')) {
      setErrors({
        loanNumber: 'Invalid format of loan number/booking number/schedule number/disbursement number'
      })
      return;
    }
    sessionStorage.setItem("email", values.email);
    sessionStorage.setItem("phone_number", values.phone);
    let userT, profileT;
    dispatch(getUserProfile(values.email, values.phone)).then((res) => {
      if (res.profiles.length < 1) {
        // alert("No profile found.");
        if (
          values.firstname == "" ||
          (values.lastname == "" && !isMuthoot) ||
          (values.email == "" && !isMuthoot) ||
          (values.phone === "" && (isMuthoot && !isCallCenterProfile))
        ) {
          setOpenSnackBar1(true);
          // alert(
          //   "enter all the details as no profile is associated with provided email"
          // );
          return 0;
        } else {
          dispatch(createGuestSignUpAnonymous(values)).then((response) => {
            sessionStorage.setItem("email", response?.user?.email);
            sessionStorage.setItem("phone_number", response?.phone_number);
            setProfile(response);
            setUser(response.user);
            profileT = response;
            userT = response.user;
            let name =
              userT.first_name +
              " " +
              userT.last_name +
              " & " +
              `${isMuthoot ? "Muthoot Finance" : companies[0]?.name}`;
            let description = name;
            let disputeBody = {
              name: name,
              company_product: isMuthoot ? values.company_product_type : values.company_product,
              business_verticle: values.company_product,
              description: description,
              grievance_type: isOrix ? 'complaint' : values.type,
              customer_type: values?.loanType,
              source_of_complaint: values?.sourceOfComplaint,
              branch: values.branch,
              city: isMuthoot ? `${values.branch.br_code} - ${values.branch.branch_name} - ${values.branch.district}` : '',
              created_by: loggedInProfile?.id,
              platform_type:
                isHotStar || isStar || isMuthoot || isWebnyay || isViacom || isDigipub || isOrix
                  ? "grievance"
                  : isCDR || isVikalp
                    ? "cdr"
                    : isNbf
                      ? "nbf"
                      : "rv",
              ...isOrix && {
                customer_type: complainCategory,
                loan_or_booking_number: values.loanNumber,
                request_ticket_number: values.ticketNumber,
                state: values.state,
                city: values.city,
                business_verticle: orixBusinessChoices.find(choice => choice.value === values.businessVertical)?.label,
              }
            };

            let createCaseBody = {
              summary: description,
              description: description,
              profile: profileT.id,
              type: CLAIMANT,
            };
            if (disputeId) {
              dispatch(updateDisputeAnonymous({ id: disputeId, ...disputeBody }, values.email))
                .then((res) => {
                  navigateToNextPage(values);
                })
            } else {
              dispatch(createDisputeAnonymous(disputeBody, values.email))
                .then((response) => {
                  createCaseBody.dispute = response;
                  sessionStorage.setItem("disputeId", response);
                  return dispatch(
                    createCaseAnonymous(createCaseBody, values.email, values.phone)
                  );
                })
                .then((response) => {
                  let respondentCaseBody = {
                    summary: createCaseBody.summary,
                    description: createCaseBody.description,
                    type: "respondent",
                    dispute: createCaseBody.dispute,
                    region: values.region,
                  };

                  return dispatch(
                    createCaseAnonymous(respondentCaseBody, values.email, values.phone)
                  );
                })
                .then((response) => {
                  navigateToNextPage(values);
                })
                // .then(() => {
                //   dispatch(testApi());
                //   dispatch(testApi2());
                // })
                .catch((err) => {
                  //console.log(err);
                });
            }
          }).catch((error) => {
            console.log(error);
          })
        }
      } else {
        if (res.profiles.length > 1) {
          alert("Multiple profiles");
          return 0;
        } else {
          setProfile(res.profiles[0]);
          setUser(res.profiles[0].user);
          profileT = res.profiles[0];
          userT = res.profiles[0].user;
          let name =
            userT.first_name +
            " " +
            userT.last_name +
            " & " +
            `${isMuthoot ? "Muthoot Finance" : companies[0]?.name}`;

          let description = name;
          let disputeBody = {
            name: name,
            company_product: isMuthoot ? values.company_product_type : values.company_product,
            business_verticle: values.company_product,
            description: description,
            grievance_type: isOrix ? 'complaint' : values.type,
            customer_type: values?.loanType,
            source_of_complaint: values?.sourceOfComplaint,
            branch: values.branch,
            city: isMuthoot ? `${values.branch.br_code} - ${values.branch.branch_name} - ${values.branch.district}` : '',
            created_by: loggedInProfile?.id,
            platform_type:
              isHotStar || isStar || isMuthoot || isWebnyay || isViacom || isDigipub || isOrix
                ? "grievance"
                : isCDR || isVikalp
                  ? "cdr"
                  : isNbf
                    ? "nbf"
                    : "rv",
            ...isOrix && {
              customer_type: complainCategory,
              loan_or_booking_number: values.loanNumber,
              request_ticket_number: values.ticketNumber,
              state: values.state,
              city: values.city,
              business_verticle: orixBusinessChoices.find(choice => choice.value === values.businessVertical)?.label,
            }
          };

          let createCaseBody = {
            summary: description,
            description: description,
            profile: profileT.id,
            type: CLAIMANT,
          };

          if (disputeId) {
            dispatch(updateDisputeAnonymous({ id: disputeId, ...disputeBody }, values.email))
              .then((res) => {
                navigateToNextPage(values);
              })
          } else {
            dispatch(createDisputeAnonymous(disputeBody, values.email))
              .then((response) => {
                createCaseBody.dispute = response;
                sessionStorage.setItem("disputeId", response);
                return dispatch(
                  createCaseAnonymous(createCaseBody, values.email, values.phone)
                );
              })
              .then((response) => {
                let respondentCaseBody = {
                  summary: createCaseBody.summary,
                  description: createCaseBody.description,
                  type: "respondent",
                  dispute: createCaseBody.dispute,
                  region: values.region,
                };

                return dispatch(
                  createCaseAnonymous(respondentCaseBody, values.email, values.phone)
                );
              })
              .then((response) => {
                navigateToNextPage(values);
              })
              // .then(() => {
              //   dispatch(testApi());
              //   dispatch(testApi2());
              // })
              .catch((err) => {
                //console.log(err);
              });
          }
        }
      }
    });
  }, 1000);

  // handler for vendor as claimant
  const onProceed = (values) => {
    setClaimantFormValues({ ...values });
    setFormStep(2);
  };

  function getUserProfile(email, phone) {
    const e = email === "" ? null : email;
    // if both email and phone are empty, return a resolved promise with empty profiles array to avoid making an unnecessary API call
    if (email === "" && phone === "") {
      return async () => ({ profiles: [] });
    }
    return async () => {
      const response = await instance.get(
        `/api/userappointmentprofilelistanonymous/${null}/${e}/${null}` + ((isMuthoot && phone) ? `/${phone}` : "")
      );
      return response.data;
    };
  }

  function createGuestSignUpAnonymous(values) {
    return async (dispatch) => {
      //   dispatch(setProgress());
      try {
        const response = await instance.post(
          "/anonymouscreateuser/",
          {
            phone_number: values.phone.trim() == "" ? null : values.phone,
            profile_type: "general",
            group: getRealhost(),
            user: {
              email: values.email,
              password: "Test@123",
              first_name: values.firstname,
              last_name: values.lastname,
              region: values.region,
            },
          },
          {
            headers: {
              "content-type": "application/json",
            },
          }
        );

        return response.data;
      } catch (error) {
        // console.log(error, error?.response?.data);
        if (error?.response?.data?.phone_number) {
          showSnackbar('Profile with this phone number already exists.', 'error')
        } else {
          alert("ERROR");
        }
      }
    };
  }

  const formik = useFormik({
    initialValues: previousFormData || {
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      company: isVendor ? profile.company : isOrix ? companies[0]?.id : null,
      company_product_type: null,
      company_product: null,
      region: "",
      type: null,
      city: null,
      state: null,
      existingCustomer: '',
      loanNumber: '',
      organizationName: '',
      helpDeskComplainRaised: true,
      ticketNumber: '',
      businessVertical: '',
      loanType: '',
      sourceOfComplaint: '',
      branch: "",
    },
    onSubmit: isVendor ? onProceed : debouncedOnSubmit,
    validationSchema: DisputeSchema,
  });

  const onPhoneChange = (e) => {
    const numericValue = e.target.value.replace(/\D/g, '').slice(0, 10);
    formik.setFieldValue("phone", numericValue);
  };

  const fieldRegistry = {
    firstname: (
      <TextField
        key="firstname"
        id="firstname"
        name="firstname"
        label={isMuthoot ? 'Full Name' : <FormattedMessage id="user.firstName" />}
        variant="outlined"
        fullWidth
        className={classes.item}
        onChange={formik.handleChange}
        value={formik.values.firstname}
      />
    ),
    lastname: (
      <TextField
        key="lastname"
        id="lastname"
        name="lastname"
        label={<FormattedMessage id="user.lastName" />}
        variant="outlined"
        fullWidth
        className={classes.item}
        onChange={formik.handleChange}
        value={formik.values.lastname}
      />
    ),
    email: (
      <TextField
        key="email"
        required={!isMuthoot}
        id="email"
        name="email"
        label={<FormattedMessage id="user.email" />}
        variant="outlined"
        fullWidth
        className={classes.item}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        value={formik.values.email}
      />
    ),
    phone: (
      <TextField
        key="phone"
        required={(isMuthoot && !isCallCenterProfile) || isOrix}
        name="phone"
        id="phone"
        label={<FormattedMessage id="user.phoneNumber" />}
        variant="outlined"
        fullWidth
        className={classes.item}
        onChange={onPhoneChange}
        value={formik.values.phone}
        inputProps={{ maxLength: 10, inputMode: 'numeric' }}
      />
    ),
    branch: (
      <SearchAutocomplete
        required
        disabled={formik.values.loanType === "Personal Loan"}
        value={formik.values.branch}
        onChange={(e, value) => {
          formik.setFieldValue("branch", value);
          formik.setFieldValue("region", value?.region.toUpperCase() || "");
        }}
        isBeforeLoginFlow={true}
      />
    ),
    region: (
      <FormControl key="region" fullWidth variant="outlined" disabled={(formik.values.loanType === "Personal Loan") || Boolean(formik.values.branch?.region)}>
        <InputLabel id="region-label" shrink={Boolean(formik.values.region)}>
          <FormattedMessage id="user.region" />
        </InputLabel>
        <Select
          required
          id="region"
          name="region"
          value={formik.values.region}
          onChange={formik.handleChange}
          labelId="region-label"
          label="Region"
        >
          {((formik.values.loanType === "Personal Loan") ? ["PL/7120"] : regions)?.map((state, index) => (
            <MenuItem key={index} value={state}>
              {state}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
    type: (
      <FormControl key="type" fullWidth variant="outlined">
        <InputLabel id="type">Type</InputLabel>
        <Select
          required
          id="type"
          name="type"
          value={formik.values.type}
          onChange={formik.handleChange}
          labelId="type"
          label="Type"
        >
          {grievanceTypes.map((type, index) => (
            <MenuItem key={index} value={type.id}>
              {type.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
    loan_type: (
      <FormControl key="loan_type" fullWidth variant="outlined">
        <InputLabel id="loan-type-label"><FormattedMessage id="user.loanType" /></InputLabel>
        <Select
          required
          id="loanType"
          name="loanType"
          value={formik.values.loanType}
          onChange={(e) => {
            formik.handleChange(e);
            if (e.target.value === "Personal Loan") {
              formik.setFieldValue("branch", { br_code: "", branch_name: "PL/7120", district: "", region: "PL/7120" });
              formik.setFieldValue("region", "PL/7120")
            } else {
              formik.setFieldValue("branch", "");
            }
          }}
          labelId="loan-type-label"
          label="Loan Type"
        >
          {loanTypes.map((type, index) => (
            <MenuItem key={index} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
    source_of_complaint: (
      <FormControl key="source_of_complaint" fullWidth variant="outlined">
        <InputLabel id="source-label"><FormattedMessage id="user.sourceOfComplaint" /></InputLabel>
        <Select
          required
          id="sourceOfComplaint"
          name="sourceOfComplaint"
          value={formik.values.sourceOfComplaint}
          onChange={formik.handleChange}
          labelId="source-label"
          label="Source of Complaint"
        >
          {sourceOfComplaints.map((type, index) => (
            <MenuItem key={index} value={type}>
              {type}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
    company: (
      <FormControl fullWidth variant="outlined" data-testid="respondent-select">
        <InputLabel id="against">
          {(isHotStar || isStar || isMuthoot) ? "Platform" : "Respondent"}
        </InputLabel>
        <Select
          id="company"
          name="company"
          value={formik.values.company}
          onChange={(e) => {
            formik.setFieldValue("company_product", null);
            formik.setFieldValue("company_product_type", null);
            formik.handleChange(e);
            companies.map((com) => {
              if (com.id == e.target.value) {
                setCompanyName(com.name);
              }
            });
            setCompanyProducts([]);
            getCompanyProductsAnonymous(e.target.value).then(
              (response) => {
                setCompanyProducts(response);
              }
            );
          }}
          labelId="against"
          label={(isHotStar || isStar || isMuthoot) ? "Platform" : "Respondent"}
        >
          {companies.map((company, index) => (
            <MenuItem key={company.id} value={company.id}>
              {company.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
    company_product_type: (
      <FormControl key="company_product_type" fullWidth variant="outlined" disabled={companyProducts?.length === 0}>
        <InputLabel id="nature-label">{isMuthoot ? "Complaint Category" : <FormattedMessage id="dispute.nature" />}</InputLabel>
        <Select
          id="company_product_type"
          name="company_product_type"
          value={formik.values.company_product_type}
          onChange={(e) => {
            formik.setFieldValue("company_product", null);
            formik.handleChange(e);
          }}
          label={isMuthoot ? "Complaint Category" : "Company"}
        >
          {isMuthoot ? (
            (Array.isArray(companyProducts?.category) ? companyProducts.category : []).map((cat, index) => (
              <MenuItem key={index} value={cat.id || cat.name}>
                {cat.name}
              </MenuItem>
            ))
          ) : (
            (Array.isArray(companyProducts) ? companyProducts : [])
              .map((item) => item.type)
              .filter(
                (value, index, self) => self.indexOf(value) === index
              )
              .map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type.replaceAll('_', ' ')}
                </MenuItem>
              ))
          )}
        </Select>
      </FormControl>
    ),
    company_product: (
      <FormControl key="company_product" fullWidth variant="outlined" disabled={companyProducts?.length === 0}>
        <InputLabel id="company_product-label">{(isHotStar || isStar) ? <FormattedMessage id="dispute.format" /> : (isMuthoot ? "Sub-category" : <FormattedMessage id="dispute.category" />)}</InputLabel>
        <Select
          id="company_product"
          name="company_product"
          value={formik.values.company_product}
          onChange={formik.handleChange}
          labelId="company_product"
          label={isMuthoot ? 'Sub-category' : 'Category'}
        >
          {isMuthoot ? (
            (companyProducts?.['sub_category'] || []).map((subCat, index) => (<MenuItem key={index} value={subCat}>{subCat}</MenuItem>))
          ) : (
            companyProducts?.filter(p => p.type === formik.values.company_product_type).map((p, index) => (
              <MenuItem key={index} value={p.id}>{p.name}</MenuItem>
            ))
          )}
        </Select>
      </FormControl>
    ),
    state: (
      <TextField
        key="state"
        required
        fullWidth
        variant="outlined"
        select
        label="State"
        name="state"
        value={formik.values.state}
        onChange={(e) => {
          formik.handleChange(e);
          setCities([]);
          formik.setFieldValue("city", "");
          getCitiesByStateName(e.target.value).then(res => setCities(res));
        }}
      >
        {INDIAN_STATES.map((state, index) => (
          <MenuItem key={index} value={state}>
            {state}
          </MenuItem>
        ))}
      </TextField>
    ),
    city: (
      <TextField
        key="city"
        required
        fullWidth
        variant="outlined"
        select
        label="City"
        name="city"
        value={formik.values.city}
        onChange={formik.handleChange}
        disabled={cities?.length === 0}
      >
        {cities?.map((city, index) => (
          <MenuItem key={index} value={city}>
            {city}
          </MenuItem>
        ))}
      </TextField>
    ),
    orix_specific_fields: (
      <Fragment key="orix_fields">
        <TextField
          required
          fullWidth
          variant='outlined'
          select
          label='Are you an existing customer of ORIX India?'
          name="existingCustomer"
          value={formik.values.existingCustomer}
          onChange={formik.handleChange}
        >
          {booleanDropdown?.map((boolean, index) => (
            <MenuItem key={index} value={boolean.value}>
              {boolean.label}
            </MenuItem>
          ))}
        </TextField>
        {formik.values.existingCustomer && (
          <>
            <TextField
              required
              fullWidth
              variant='outlined'
              select
              label='Which business vertical are you a customer of ORIX India?'
              name="businessVertical"
              value={formik.values.businessVertical}
              onChange={(e) => {
                formik.handleChange(e);
                setComplainCategory(categorizeInput(formik.values.loanNumber, e.target.value));
              }}
            >
              {orixBusinessChoices?.map((business, index) => (
                <MenuItem key={index} value={business.value}>
                  {business.label}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              variant="outlined"
              value={formik.values.loanNumber}
              required
              fullWidth
              label='Loan Number/Booking Number/Schedule Number/Disbursement Number'
              name="loanNumber"
              onChange={(e) => {
                formik.handleChange(e);
                setErrors({ loanNumber: '' })
                setComplainCategory(categorizeInput(e.target.value, formik.values.businessVertical));
              }}
              InputProps={{
                endAdornment: (complainCategory && formik.values.loanNumber.trim()) && (
                  <Typography style={{ backgroundColor: '#a8f7e3b0', padding: '2px 5px', borderRadius: '3px', lineHeight: 'normal' }}>
                    {complainCategory}
                  </Typography>
                )
              }}
              error={errors?.loanNumber}
              helperText={errors?.loanNumber}
            />
            {formik.values.businessVertical === 'lease_business' && (
              <TextField
                variant="outlined"
                value={formik.values.organizationName}
                fullWidth
                label='Your Organization Name'
                name="organizationName"
                onChange={formik.handleChange}
              />
            )}
            <TextField
              required
              fullWidth
              variant='outlined'
              select
              label='Have you already raised your concern to ORIX India customer service desk?'
              name="helpDeskComplainRaised"
              value={formik.values.helpDeskComplainRaised}
              onChange={formik.handleChange}
              InputLabelProps={{ shrink: true }}
            >
              {booleanDropdown?.map((boolean, index) => (
                <MenuItem key={index} value={boolean.value}>
                  {boolean.label}
                </MenuItem>
              ))}
            </TextField>
            {formik.values.helpDeskComplainRaised && (
              <TextField
                required
                variant="outlined"
                value={formik.values.ticketNumber}
                fullWidth
                label='Request Ticket Number'
                name="ticketNumber"
                onChange={formik.handleChange}
              />
            )}
          </>
        )}
      </Fragment>
    )
  };

  const getFieldOrder = () => {
    if (isMuthoot) {
      return ["firstname", "phone", "email", "type", "company", "loan_type", "branch", "region", "source_of_complaint", "company_product_type", "company_product"];
    }
    if (isOrix) {
      return ["firstname", "lastname", "email", "phone", "state", "city", "orix_specific_fields"];
    }
    if (isVendor) {
      return ["firstname", "lastname", "email", "phone", "company_product_type", "company_product"];
    }
    return ["firstname", "lastname", "email", "phone", "company", "company_product_type", "company_product"];
  };

  return (
    <Box p="2rem 0">
      <Grid container spacing={3}>
        <Grid item xs></Grid>
        <Grid item xs={10} md={6}>
          <Paper className={classes.formContainer}>
            <Box>
              <Typography variant="h4" gutterBottom align="center">
                <FormattedMessage id="pages.intro.introText" />
              </Typography>
              <Box height="1rem"></Box>
              <Box p="0rem 2rem">
                <form onSubmit={formik.handleSubmit} data-testid="intro-form" style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                  {getFieldOrder().map((fieldKey) => (
                    <Fragment key={fieldKey}>
                      {fieldRegistry[fieldKey]}
                      {formik.errors[fieldKey] && formik.touched[fieldKey] && (
                        <Alert severity="error">{formik.errors[fieldKey]}</Alert>
                      )}
                    </Fragment>
                  ))}

                  <Box height="1rem"></Box>
                  <Box display="flex" justifyContent="center">
                    {caseLoading || disputeLoading ? (
                      <CircularProgress />
                    ) : (
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={caseLoading || disputeLoading}
                        className={(isHotStar || isStar || isMuthoot || isOrix) && classes.hoverButton}
                      >
                        {isVendor ? (
                          <FormattedMessage id="buttons.proceed" />
                        ) : (
                          <FormattedMessage id="buttons.submit" />
                        )}
                      </Button>
                    )}
                  </Box>
                </form>
              </Box>
            </Box>
          </Paper>
          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            autoHideDuration={5000}
            open={openSnackBar1}
            onClose={handleCloseSnackBar1}
            message="Enter all the details as no profile is associated with provided email"
          // key={vertical + horizontal}
          >
            <Aler onClose={handleCloseSnackBar1} severity="error">
              {isMuthoot || isOrix ? 'Please enter all details.' : 'Enter all the details as no profile is associated with provided email'}
            </Aler>
          </Snackbar>
        </Grid>
        <Grid item xs />
      </Grid>
    </Box>
  );
};

export default IntroForm;